import { JSX, useEffect, useState } from 'react'
import classNames from 'classnames'

import styles from './Spinner.module.css'

type SpinnerProps = {
    className: string
    delay?: boolean
    layout?: 'default' | 'overlay' | 'container'
}

export const Spinner = ({ className, delay, layout }: SpinnerProps): JSX.Element | null => {
    const [render, setRender] = useState(delay ? false : true)

    useEffect(() => {
        if (delay) {
            // -- only show loader if it takes more than 1sec
            const timerId = setTimeout(() => setRender(true), 1000)

            return () => clearTimeout(timerId)
        }
    }, [delay])

    if (!render) {
        return null
    }

    const element = (
        <div className={classNames(className, styles.dots)}>
            <svg viewBox="0 0 64 64">
                <circle transform="translate(32,32)" r="6" />
            </svg>
            <svg viewBox="0 0 64 64">
                <circle transform="translate(32,32)" r="6" />
            </svg>
            <svg viewBox="0 0 64 64">
                <circle transform="translate(32,32)" r="6" />
            </svg>
        </div>
    )

    if (layout !== 'default') {
        return (
            <div
                className={classNames({
                    'absolute bottom-0 left-0 right-0 top-0 z-50 flex items-center justify-center bg-black/50':
                        layout === 'overlay',
                    'flex h-full w-full items-center justify-center': layout === 'container',
                })}
            >
                {element}
            </div>
        )
    }

    return element
}
